import { Component, OnInit } from '@angular/core';
import { Title }  from '@angular/platform-browser';
import { Router } from '@angular/router';
import { source, DatabaseParams, FileSourceParams, WebsiteParams} from './source';
import { CommonService } from '../../servies/common/common.service'
@Component({
    selector: 'app-default',
    templateUrl: './addsource.component.html',
    styleUrls: []
  })
  export class AddSourceComponent implements OnInit {
    logged_in_username:string="";
    public sourcetypes:string[]=["File","Database","Website"];
     sourceData:source=new source();
     
    
    constructor(private router:Router,private common:CommonService){
        if(sessionStorage.getItem('loggedin')=='false' || sessionStorage.getItem('loggedin')==null)
        {      
          this.gotoLogin();
        }    
        else if(sessionStorage.getItem('loggedin')=='true'){
          this.logged_in_username= sessionStorage.getItem('loggedinname');
          //this.router.getCurrentNavigation().extras.state.logged_in_user;     
        }
      }
      gotoLogin(){    
        this.router.navigate(['/login']);  // define your component where you want to go
      }
      savesource(data){
          this.common.savefile(data).subscribe(
            success => {
              if(success=="success"){
              alert("Source "+data.name+" created successfully")
              this.common.stoplogstash().subscribe()
              setTimeout(() => 
                  {
                      this.router.navigate(['/search']);
                  },
                  2000);
              return true;
              }
              else{
                alert("Please Wait! Another Source is indexing..")
              }
            },
            error => {
              console.log(error)
              alert("Source Creation failed..")
              return false;
            });
      
      }
      ngOnInit(){
        this.sourceData.type="File"
        this.sourceData.database=new DatabaseParams();
        this.sourceData.file=new FileSourceParams();
        this.sourceData.website=new WebsiteParams();
        this.sourceData.database.driverLibrary='/usr/share/logstash/mysql-connector-java-5.1.38.jar';
        this.sourceData.database.driverClass='com.mysql.jdbc.Driver'
      }

    
}